module.exports = __webpack_public_path__ + "static/media/fa-light-300.d2347916.woff2";